import request from '@/utils/request'

/**
 * 获取基本配置
 * @param query
 * @returns {*}
 */
export function getBaseConfig(query) {
    return request({
        url: '/baseconfig',
        method: 'get',
        params: query
    })
}

/**
 * 获取导航
 * @param query
 * @returns {*}
 */
export function getNavs(query){
    return request({
        url: '/navs',
        method: 'get',
        params: query
    })
}

/**
 * 获取轮播图
 * @param query carousels?nav=
 * @returns {*}
 */
export function getCarousels(query){
    return request({
        url: '/carousels',
        method: 'get',
        params: query
    })
}

/**
 * 获取首页动态通知
 * @param query
 * @returns {*}
 */
export function getMovingNotices(query){
    return request({
        url: '/movingnotices',
        method: 'get',
        params: query
    })
}


/**
 * 获取文章
 * @param query aritcles?nav=1
 * @returns {*}
 */
export function getArticles(query){
    return request({
        url: '/aritcles',
        method: 'get',
        params: query
    })
}

/**
 * 获取首页(轮播)内容
 * @param query
 * @returns {*}
 */
export function getContentCarousels(query){
    return request({
        url: '/content-carousels',
        method: 'get',
        params: query
    })
}

export function getCertProducts(query){
    return request({
        url: '/cert-products',
        method: 'get',
        params: query
    })
}
